import { Row } from "../../../../core/components/Row";
import { TextComponent } from "../../../../core/components/TextComponent";
import { businessName, urlBusinessName } from "../../../../core/constants/utils";

export const Footer = () => {
	return (
		<Row
			mainAxisAlignment="center"
			className="w-full text-black opacity-70 mt-auto px-4 py-5 text-sm lg:text-base bg-lightPurple"
		>
			<a
				href={urlBusinessName}
				target="_blank"
				rel="noreferrer"
			>
				<TextComponent variant="h6" className="font-medium">
					Creado con ♥️ por <span className="underline font-bold text-darkPurple">{businessName}</span>
				</TextComponent>
			</a>
		</Row>
	);
};
